import { useReduxState } from 'hooks';
import api from 'api';
import { Alert, ConfirmButton } from 'components/common';

interface Props {
  achievementId: number;
  disabled?: boolean;
  supervisorId?: number;
  tooltip?: string;
  updateData: () => Promise<void>;
  warning?: string;
}

const AchievementSupervisorsRemove = ({
  achievementId,
  disabled,
  supervisorId,
  tooltip,
  updateData,
  warning
}: Props) => {
  const { messages } = useReduxState();

  const handleConfirm = async () => {
    try {
      await api.delete(
        `admin/achievements/${achievementId}/supervisors${
          supervisorId ? `/${supervisorId}` : ''
        }`
      );

      await updateData();
      return true;
    } catch (err) {
      return false;
    }
  };

  return (
    <ConfirmButton
      actionText={messages.commonRemove}
      buttonCategory="danger"
      buttonIcon="trash-alt"
      buttonText={messages.adminSupervisorsRemove}
      buttonTooltip={tooltip}
      category="danger"
      disabled={disabled}
      confirmText={
        <div>
          {warning ? (
            <Alert
              style={{ marginBottom: 20 }}
              text={warning}
              type="warning-light"
            />
          ) : null}

          {messages.achievementSupervisorRemove}
        </div>
      }
      confirmTitle={messages.adminSupervisorsRemove}
      onConfirm={handleConfirm}
      successMessage={messages.adminSupervisorsRemoveSuccess}
    />
  );
};

export default AchievementSupervisorsRemove;
